/* ATB Home Page behavior. One IIFE, no globals, no jQuery. Loaded with defer on the home page only. */
(function () {
  'use strict';
  var root = document.documentElement;
  if (root.hasAttribute('data-atb-home-js')) return;
  root.setAttribute('data-atb-home-js', '1');

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Add to cart (uses the theme's own cart drawer) ---------- */
  function setMsg(el, text) {
    if (el) el.textContent = text || '';
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-disabled') === 'true' || btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    var wrap = btn.parentNode;
    var msg = wrap ? wrap.querySelector('.atb-home-msg') : null;
    setMsg(msg, '');
    var label = btn.textContent;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('atb-home-loading');
    btn.textContent = 'Adding...';

    var cart = document.querySelector('cart-drawer');
    var payload = { id: Number(id), quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      payload.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, j: j }; });
      })
      .then(function (res) {
        if (!res.ok || res.j.status) {
          throw new Error(res.j.description || res.j.message || 'We could not add this item. Please try again.');
        }
        if (cart && typeof cart.renderContents === 'function') {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'atb-home' });
          }
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
          cart.renderContents(res.j);
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function (err) {
        setMsg(msg, err && err.message ? err.message : 'We could not add this item. Please try again.');
      })
      .then(function () {
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('atb-home-loading');
        btn.textContent = label;
      });
  }

  /* ---------- Tabs ---------- */
  function activateTab(tab, focus) {
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var tabs = list.querySelectorAll('[role="tab"]');
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      var on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = document.getElementById(t.getAttribute('aria-controls'));
      if (panel) {
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      }
    }
    if (focus) tab.focus();
    syncSlides(tab);
  }

  function onTabKey(e) {
    var tab = e.target.closest('[role="tab"]');
    if (!tab) return;
    var list = tab.closest('[role="tablist"]');
    var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var i = tabs.indexOf(tab);
    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') next = tabs[0];
    else if (e.key === 'End') next = tabs[tabs.length - 1];
    if (next) {
      e.preventDefault();
      activateTab(next, true);
    }
  }

  /* ---------- Featured brands: counter and dots follow the selected brand ---------- */
  function syncSlides(tab) {
    var scope = tab.closest('[data-atb-slides]');
    if (!scope) return;
    var chips = scope.querySelectorAll('[data-atb-chip]');
    var idx = 0;
    for (var i = 0; i < chips.length; i++) {
      if (chips[i].getAttribute('aria-selected') === 'true') idx = i;
    }
    var count = scope.querySelector('[data-atb-count]');
    if (count) count.textContent = (idx + 1) + ' of ' + chips.length;
    var dots = scope.querySelectorAll('[data-atb-goto]');
    for (var d = 0; d < dots.length; d++) {
      if (d === idx) dots[d].setAttribute('aria-current', 'true');
      else dots[d].removeAttribute('aria-current');
    }
  }

  function stepSlides(btn) {
    var scope = btn.closest('[data-atb-slides]');
    if (!scope) return;
    var chips = Array.prototype.slice.call(scope.querySelectorAll('[data-atb-chip]'));
    var cur = 0;
    chips.forEach(function (c, i) { if (c.getAttribute('aria-selected') === 'true') cur = i; });
    var dir = Number(btn.getAttribute('data-atb-step')) || 1;
    var next = chips[(cur + dir + chips.length) % chips.length];
    if (next) activateTab(next, false);
  }

  function gotoSlide(btn) {
    var scope = btn.closest('[data-atb-slides]');
    if (!scope) return;
    var chips = scope.querySelectorAll('[data-atb-chip]');
    var idx = Number(btn.getAttribute('data-atb-goto'));
    if (chips[idx]) activateTab(chips[idx], false);
  }

  /* ---------- Deals carousel (native scroll snap, so touch swipe just works) ---------- */
  function initDeals(box) {
    if (box.getAttribute('data-atb-ready') === '1') return;
    var view = box.querySelector('[data-atb-view]');
    var prev = box.querySelector('[data-atb-prev]');
    var next = box.querySelector('[data-atb-next]');
    var dotsBox = box.querySelector('[data-atb-pages]');
    var counter = box.querySelector('[data-atb-pagecount]');
    var cards = view ? view.querySelectorAll('.atb-home-car-card') : [];
    if (!view || !cards.length) return;
    box.setAttribute('data-atb-ready', '1');
    var dotCount = -1;

    function metrics() {
      var gap = 16;
      var cw = cards[0].getBoundingClientRect().width;
      var step = cw + gap;
      var vis = Math.max(1, Math.round((view.clientWidth + gap) / step));
      return { step: step, vis: vis, max: Math.max(0, cards.length - vis) };
    }

    function pages(m) {
      var list = [];
      for (var i = 0; i < cards.length - m.vis + m.vis; i += m.vis) {
        list.push(Math.min(i, m.max));
      }
      var out = [];
      list.forEach(function (n) { if (out.indexOf(n) === -1) out.push(n); });
      if (out[out.length - 1] !== m.max) out.push(m.max);
      return out;
    }

    function update() {
      var m = metrics();
      var idx = Math.min(m.max, Math.round(view.scrollLeft / m.step));
      var atStart = view.scrollLeft <= 2;
      var atEnd = view.scrollLeft >= view.scrollWidth - view.clientWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
      if (counter) counter.textContent = (idx + 1) + ' to ' + Math.min(cards.length, idx + m.vis) + ' of ' + cards.length;
      if (dotsBox) {
        var pg = pages(m);
        if (dotCount !== pg.length) {
          dotsBox.innerHTML = '';
          pg.forEach(function (n, k) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'atb-home-pg';
            b.setAttribute('aria-label', 'Show deals page ' + (k + 1));
            b.setAttribute('data-atb-page', String(n));
            dotsBox.appendChild(b);
          });
          dotCount = pg.length;
        }
        var cur = 0;
        pg.forEach(function (n, k) { if (idx >= n) cur = k; });
        if (atEnd) cur = pg.length - 1;
        var bs = dotsBox.querySelectorAll('.atb-home-pg');
        for (var j = 0; j < bs.length; j++) {
          if (j === cur) bs[j].setAttribute('aria-current', 'true');
          else bs[j].removeAttribute('aria-current');
        }
      }
    }

    function go(left) {
      view.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { var m = metrics(); go(view.scrollLeft - m.step * m.vis); });
    if (next) next.addEventListener('click', function () { var m = metrics(); go(view.scrollLeft + m.step * m.vis); });
    if (dotsBox) {
      dotsBox.addEventListener('click', function (e) {
        var b = e.target.closest('[data-atb-page]');
        if (!b) return;
        go(Number(b.getAttribute('data-atb-page')) * metrics().step);
      });
    }
    var ticking = false;
    view.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    var resizeTimer;
    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { dotCount = -1; update(); }, 120);
    });
    update();
  }

  /* ---------- Evolve pool size picker ---------- */
  function evolveUpdate(sel) {
    var box = sel.closest('[data-atb-evolve]');
    if (!box) return;
    var opt = sel.options[sel.selectedIndex];
    if (!opt) return;
    var q = function (s) { return box.querySelector(s); };
    var price = q('[data-evo-price]');
    var compare = q('[data-evo-compare]');
    var save = q('[data-evo-save]');
    var model = q('[data-evo-model]');
    var add = q('[data-evo-add]');
    var msg = q('.atb-home-msg');
    var photo = q('[data-evo-photo]');
    var cmp = opt.getAttribute('data-compare');
    if (price) price.textContent = opt.getAttribute('data-price');
    if (compare) {
      compare.textContent = cmp || '';
      compare.hidden = !cmp;
    }
    if (save) {
      var sv = opt.getAttribute('data-save');
      save.textContent = sv ? 'Save ' + sv : '';
      save.hidden = !sv;
    }
    if (model) model.textContent = 'Model: ' + opt.getAttribute('data-model');
    if (photo && opt.getAttribute('data-image')) {
      photo.setAttribute('src', opt.getAttribute('data-image'));
      photo.removeAttribute('srcset');
    }
    if (add) {
      add.setAttribute('data-variant-id', opt.getAttribute('data-variant-id'));
      if (opt.getAttribute('data-available') === 'true') {
        add.disabled = false;
        add.textContent = 'Add to cart';
      } else {
        add.disabled = true;
        add.textContent = 'Sold out';
      }
    }
    setMsg(msg, '');
  }

  /* ---------- Events (delegated so theme editor re-renders keep working) ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-atb-add]');
    if (add && add.closest('.atb-home')) {
      e.preventDefault();
      addToCart(add);
      return;
    }
    var tab = e.target.closest('.atb-home [role="tab"]');
    if (tab) {
      activateTab(tab, false);
      return;
    }
    var step = e.target.closest('.atb-home [data-atb-step]');
    if (step) {
      stepSlides(step);
      return;
    }
    var go = e.target.closest('.atb-home [data-atb-goto]');
    if (go) gotoSlide(go);
  });

  document.addEventListener('keydown', function (e) {
    if (e.target.closest && e.target.closest('.atb-home [role="tablist"]')) onTabKey(e);
  });

  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-atb-evolve-select]');
    if (sel) evolveUpdate(sel);
  });

  function initAll(scope) {
    var boxes = (scope || document).querySelectorAll('[data-atb-deals]');
    for (var i = 0; i < boxes.length; i++) initDeals(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
